<template>
    <transition name="login_background_transition">
        <div class="login_div" v-show="show">
            <transition name="login_dialog_transition">
                <div class="login_dialog_div" v-show="show"
                >
                    <div class="nav_bar">
                        <div class="close_dialog_div">
                            <span class="close_dialog_span"
                                  @click="close_dialog()"
                            >×</span>
                        </div>

                    </div>
                    <div style="margin-bottom: 30px;">
                        <div class="content">
                            {{title}}
                        </div>
                        <div class="content">
                            {{content}}
                        </div>
                    </div>
                    <div class="publish_tools">
                        <div class="publish_operation_tools">
                            <button v-for="button in buttons" :key="button['name']" :class="button.style"
                                    @click="do_method(button.method,button.params)">{{button.name}}
                            </button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script type="text/javascript">
    import {mapState, mapActions} from 'vuex'

    export default {
        props: {
            title: {
                type: String,
                require: false
            },
            content: {
                type: String,
                require: false
            },
            buttons: {
                type: Array,
                require: false
            },
            show: {
                type: Boolean,
                require: false
            }
        },
        data: function () {
            return {
            }
        },
        components: {},

        computed: {
            ...mapState({
            })
        },
        watch: {},
        methods: {
            ...mapActions({
            }),
            do_method: async function (method,params) {
                this.$emit(method,params)
            },
            close_dialog:function () {
                this.$emit('close_dialog')
            }
        }
    }
</script>
<style type="text/css" scoped>
    .login_div {
        height: 100%;
        width: 100%;
        position: fixed;
        background: rgb(0, 0, 0, 0.5);
        z-index: 99;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .login_dialog_div {
        opacity: 1;
        width: 550px;
        margin: 80px auto;
        margin-top: 50px;
        background: #fff;
        padding: 10px 20px;
        border-radius: 4px;
        border: 1px solid rgba(0, 0, 0, 0.2);
    }

    /* 登陆背景会淡出 */

    .login_background_transition-leave-active {
        transition: all .4s ease-out;
    }

    .login_background_transition-leave {
        opacity: 1;
    }

    .login_background_transiotion-leave-to {
        opacity: 0;
    }

    /* 登录框会从上至下出来 */

    .login_dialog_transition-enter-active, .login_dialog_transition-leave-active {
        transition: all .3s ease-out;
    }

    .login_dialog_transition-enter, .login_dialog_transition-leave-to {
        transform: translate(0, -35%);
        opacity: 0.3;
    }

    .login_dialog_transition-enter-to, .login_dialog_transition-leave {
        transform: translate(0, 0);
        opacity: 1;
    }

    .close_dialog_div {
        text-align: right;
        color: #000;
        opacity: .2;
        font-size: 21px;
        font-weight: 700;
        text-shadow: 0 1px 0 #fff;
        cursor: pointer;
        height: 20px;
    }

    .nav_bar_ul {
        display: flex;
        justify-content: space-around;
        border: none;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    .nav_bar_li {
        width: 50%;
        text-align: center;
    }

    .nav_bar_li:hover {
        border-bottom: 1px solid #6CF;
    }

    .nav_bar_a {
        display: block;
        font-weight: 700;
        padding: 15px;
        font-size: 18px;
        color: #555;
    }

    .nav_bar_li_active {
        border-bottom: 1px solid #6CF;
    }

    .button-primary {
        padding: 6px 20px;
        background: rgb(8, 191, 145);
        border: 1px solid transparent;
        border-radius: 4px;
        font-size: 16px;
        text-align: center;
        color: #fff;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        margin-right: 5px;
    }

    .button-default {
        background-color: #fff;
        color: #66CCFF;
        border-color: #66CCFF;
    }

    .publish_operation_tools {
        display: flex;

    }

    .content {
        font-size: 20px;
        padding: .375rem .75rem;
        width: 100%;
        line-height: 1.5;
        border: 0;
        outline: none;
        box-shadow: none;
        resize: none;
        color: #66ccff;
        /*background: #f9f9f9;*/
    }

</style>
